import React, { Component, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import DailyReportsServices from "../../services/axiosServices/apiServices/DailyReportsServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { set } from "date-fns";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class StockRegister extends Component {
  constructor(props) {
    super(props);
    this.dailyReportsServices = new DailyReportsServices();
    this.state = {
      isTable2Expanded: false,
      isTable3Expanded: false,
      prop: {},
      table3Data: [],
      table3ColDefs: [],
      table2Data: [],
      table2ColDefs: [],
      rowData: [
      ],

      colDefs: [
        {
          field: "drawingNo",
          headerName: "Drawing no",
          width: Math.max(window.innerWidth * 0.1, 50),
          filter: true,
          floatingFilter: true,
          pinned: "left"
        },
        {
          field: "searchText",
          headerName: "Search text",
          width: Math.max(window.innerWidth * 0.09, 50),
          filter: true,
          floatingFilter: true,
          pinned: "left"
        },
        {
          field: "itemCategory",
          headerName: "Item category",
          width: Math.max(window.innerWidth * 0.08, 50),
          filter: true,
          floatingFilter: true,
          pinned: "left"
        },
        {
          field: "itemName",
          headerName: "Item name",
          width: Math.max(window.innerWidth * 0.15, 50),
          filter: true,
          floatingFilter: true,
          pinned: "left"
        },
        {
          field: "location",
          headerName: "Location",
          width: Math.max(window.innerWidth * 0.06, 50),
          flex: 1,
          filter: true,
          floatingFilter: true,
          pinned: "left"
        },
        {
          field: "opStock",
          headerName: "Op stock",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "mrsQty",
          headerName: "MRS qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "piQty",
          headerName: "PI qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "poQty",
          headerName: "PO qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "qcQty",
          headerName: "QC qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "storeQty",
          headerName: "Store qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "plant",
          headerName: "Plant",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "workPlanningQty",
          headerName: "Work planning qty",
          minWidth: window.innerWidth * 0.07,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "rejectQty",
          headerName: "Reject qty",
          minWidth: window.innerWidth * 0.05,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "jobWorkQty",
          headerName: "Job work qty",
          minWidth: window.innerWidth * 0.05,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "issueQty",
          headerName: "Issue qty",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "inProcess",
          headerName: "In process",
          minWidth: window.innerWidth * 0.05,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "occupieQty",
          headerName: "Occupie qty",
          minWidth: window.innerWidth * 0.05,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "salesReturn",
          headerName: "Sales return",
          minWidth: window.innerWidth * 0.05,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
        {
          field: "scrap",
          headerName: "Scrap",
          minWidth: window.innerWidth * 0.04,
          flex: 1,
          filter: true,
          floatingFilter: true,
        },
      ],
      caption: "",
      colName: "",
      // rowData2:[],
      // colDefs2:[],
      paginationPageSize: 50, // Number of rows per page
      rowHeight: 40,
    };
    this.gridApi = null;
  }

  handleCellClick = (event) => {
    //debugger
    if (
      event.colDef.field === "piQty" ||
      event.colDef.field === "plant" ||
      event.colDef.field === "mrsQty" ||
      event.colDef.field === "poQty" ||
      event.colDef.field === "qcQty" ||
      event.colDef.field === "storeQty" ||
      event.colDef.field === "workPlanningQty" ||
      event.colDef.field === "rejectQty" ||
      event.colDef.field === "jobWorkQty" ||
      event.colDef.field === "issueQty" ||
      event.colDef.field === "processStock" ||
      event.colDef.field === "poQty"
    ) {
      this.procItemStockRegister_TrackingDetails(event.data.idItem, event.colDef.field);
    }
  };

  handleCellClick2 = (event) => {
    //if (event.colDef.field === "piQty") {
    this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], this.state.caption);
    //}
  };

  toggleExpandCollapseTable = (tableNumber) => {
    this.setState((prevState) => {
      if (tableNumber === 2) {
        return { isTable2Expanded: !prevState.isTable2Expanded };
      } else if (tableNumber === 3) {
        return { isTable3Expanded: !prevState.isTable3Expanded };
      } else {
        return {};
      }
    });
  };

  componentDidMount = () => {
    let prop = getAuthProps()
    //debugger
    if (prop) {
      this.setState({ prop: prop }, () => {
        this.procItemStockRegister();
      });
    } else {
      //window.location.href = "/Login";
    } setTimeout(() => {
      this.removeDefaultBorders();
    }, 100);
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay(); // Show loading overlay initially
    setTimeout(() => {
      this.removeDefaultBorders();
    }, 0);
    // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

  };
  removeDefaultBorders = () => {
    // Select pinned columns and headers
    const pinnedHeader = document.querySelector(".ag-pinned-left-header");

    // Remove border from header
    if (pinnedHeader) {
      pinnedHeader.style.borderRight = "none";
    }

    // Function to remove borders from all pinned cells
    const removeCellBorders = () => {
      const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
      pinnedCells.forEach((cell) => {
        cell.style.borderRight = "none";
      });
    };

    // Initial removal of cell borders
    removeCellBorders();

    // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
    const observer = new MutationObserver(() => {
      if (pinnedHeader) pinnedHeader.style.borderRight = "none";
      removeCellBorders(); // Continuously remove borders from new cells
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };
  // onGridScroll = (event) => {
  //   const pinnedHeader = document.querySelector(".ag-pinned-left-header");
  //   const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
  //   const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");
  //   if (event.left > 0) {
  //     // Show border when scrolling right
  //     if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
  //     if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
  //   } else {
  //     // Hide border when at the left
  //     if (pinnedHeader) pinnedHeader.style.borderRight = "none";
  //     if (pinnedRow) pinnedRow.style.borderRight = "none";
  //   }
  // };

  procItemStockRegister = () => {
    if (this.gridApi) {
      this.gridApi.showLoadingOverlay(); // Show AG Grid's loading overlay
    }

    let request = {
      fromDate: new Date(),
      toDate: new Date(),
      idItemCategory: 0,
      idCompany: this.state.prop.idCompany,
      idPlant: this.state.prop.idPlant ? this.state.prop.idPlant : 1,
      isAdmin: this.state.prop.isAdmin ? this.state.prop.isAdmin : null,
    };
    this.dailyReportsServices.procItemStockRegister(request).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        //debugger;
        let data = response.responseItem.responseContent;
        this.setState({ rowData: data }, () => {
          if (this.gridApi) {
            this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
          }
          //let data = this.state.userDetails;
          //data.databaseName = databasename;
          //this.setState({ rowData: data })
          //this.goToNextStep()
        });
      }
    });
  }

  procItemStockRegister_TrackingDetails = (idItem, caption) => {

    let request = {
      idItem: idItem,
      caption: caption,
      idCompany: this.state.prop.idCompany
    }
    //debugger
    this.dailyReportsServices.procItemStockRegister_TrackingDetails(request).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        const dynamicData = response.responseItem.responseContent;
        if (dynamicData.length > 0) {
          const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
            field: key,
            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
            flex: 1,
            valueFormatter: key.includes("piDate") ? (params) => {
              if (!params.value) return "";
              const date = new Date(params.value);
              return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
            } : undefined,
          }));
          var colName = dynamicColDefs[0].field;
          let id = dynamicData ? dynamicData[0][colName] : 0;
          this.setState({
            table2Data: dynamicData,
            table2ColDefs: dynamicColDefs,
            isTable2Expanded: true,
            isTable3Expanded: true,
            caption: caption,
            colName: colName
          }, () => {
            this.procSelectAllRecord2GridviewSP(id, caption);
          });
        }
      }
    });
  }

  procSelectAllRecord2GridviewSP = (id, formname) => {
    let request = {
      id: id,
      formname: formname,
      //idCompany: this.state.prop.idCompany
    }
    //debugger
    this.dailyReportsServices.procSelectAllRecord2GridviewSP(request).then((response) => {
      //debugger
      if (response.statusCode == 200 && response.responseItem !== null) {
        //debugger;
        const dynamicData = response.responseItem.responseContent;
        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
          field: key,
          headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
          flex: 1
        }));
        this.setState({
          table3Data: dynamicData,
          table3ColDefs: dynamicColDefs
        });
      }
    });
  }

  render() {
    return (
      <div className="stock-register-page">
        <div className="data-display">
          <div className="data-display-inner">
            <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className="table-1 h-[448px] w-full px-[1px] rounded-[5px]">
                <div className="table-inner">
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item stock register</h1>
                </div>
                <AgGridReact
                  rowData={this.state.rowData} // Pass row data
                  rowHeight={this.state.rowHeight}
                  columnDefs={this.state.colDefs}
                  headerHeight={65} 
                  pagination={true} // Enable pagination
                  paginationPageSize={this.state.paginationPageSize}
                  onCellClicked={this.handleCellClick}
                  onGridReady={this.onGridReady} // Capture API reference
                  overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'} // Custom loading text
                />
              </div>
            </div>
            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item tracking details</h1>
                </div>
                <AgGridReact
                  rowData={this.state.table2Data}
                  columnDefs={this.state.table2ColDefs}
                  rowHeight={this.state.rowHeight}
                  pagination={true} // Enable pagination
                  paginationPageSize={this.state.paginationPageSize}
                  onGridReady={this.onGridReady}
                  onCellClicked={this.handleCellClick2}
                />
              </div>
            </div>
            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className={`table-3 w-full px-[1px] rounded-[5px] ${this.state.isTable3Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(3)}>
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Transaction details</h1>
                </div>
                <AgGridReact
                  rowData={this.state.table3Data}
                  columnDefs={this.state.table3ColDefs}
                  rowHeight={this.state.rowHeight}
                  pagination={true} // Enable pagination
                  paginationPageSize={this.state.paginationPageSize}
                  rowSelection={this.rowSelection}
                  onGridReady={this.state.onGridReady} // Rows per page
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default StockRegister;